import { Router, NavModel, RouteConfig } from 'aurelia-router';
import { I18N } from 'aurelia-i18n';
import { mock, instance, verify, when, anyNumber, anything, resetCalls } from 'ts-mockito';
import { MyDocuments } from './my-documents';
import { PayrazrService } from '../../services/payrazr';
import { MessagesService } from '../../services/messages.service';
import { State } from '../../services/global-state';
import config from '../../config/config';
import { Customer, Account } from '../../models/customer';
import { DialogService } from 'aurelia-dialog';

describe('NewPortalWeb', () => {
	describe('pages', () => {
		describe('my-documents', () => {
			let component: MyDocuments;
			const mockState: State = mock(State);
			const mockCustomer: Customer = mock(Customer);
			const mockPayrazrService: PayrazrService = mock(PayrazrService);
			const mockI18N: I18N = mock(I18N);
			const mockDialogService = mock(DialogService);

			// Mock I18N Dependencies
			beforeEach(() => {
				const i18next = {
					t: (a, b) => a
				};
				when(mockI18N.i18next).thenReturn(i18next);
				spyOn(i18next, 't').and.returnValue('localized');
			});

			// Initialize Component
			beforeEach(() => {
				const business = {
					portalId: 'ABCDEFG123456'
				};
				const accounts = [];
				when(mockState.business).thenReturn(business);
				when(mockState.accounts).thenReturn(accounts);
				when(mockCustomer.accounts).thenReturn(accounts);
				component = new MyDocuments(
					instance(mockPayrazrService),
					instance(mockState),
					instance(mockI18N),
					instance(mockDialogService)
				);
			});

			it('should initialize component', () => {
				expect(component).toBeTruthy();
				expect(component.downloadLink).toEqual(`${config.serviceUrl}/portal/ABCDEFG123456`);
				expect(component.showUploadBtn).toBeTruthy();
				expect(component.showSpinner).toBeFalsy();
			});

			describe('getDocumentsList()', () => {
				it('should set documents on success', async () => {
					const list = [
						{
							test: 'test'
						}
					];
					component.documentLists = [];
					when(mockPayrazrService.getRehabDocumentsList(anything()))
						.thenResolve(list);
					await component.getDocumentsList(anything());
					expect(component.documentLists).toEqual(list);

					// expect(mockState.documentLists).toEqual(list); // TODO: figure out how to verify this with ts-mockito
				});
				it('should handle errors', async () => {
					const error = new Error('TESTERROR');
					when(mockPayrazrService.getRehabDocumentsList(anything()))
						.thenReject(error);
					await component.getDocumentsList(anything());
					expect(component.documentLists.length).toEqual(0);
					expect(component.error).toEqual('Unable to retrieve documents. Please refresh the page to retry.');
				});
			});

			describe('downloadFile()', () => {
				it('should call to payrazr.downloadFile', () => {
					when(mockPayrazrService.downloadFile(anything(), anything())).thenReturn();
					component.downloadFile('', '');
					verify(mockPayrazrService.downloadFile(anything(), anything())).called();
				});
			});

			describe('get documents()', () => {
				it('should build a list of documents', () => {
					component.documentLists = [
						{
							customerAccountReferenceId: 'test',
							documents: [
								{
									customerAccountReferenceId: 'test',
									documentType: 'Invoice Document',
								},
								{
									customerAccountReferenceId: 'test',
									documentType: 'test2',
								},
							]
						},
					];

					const list = component.documents;
					expect(list.length).toEqual(2);
					expect(list[0].documentType).toEqual('localized');
					expect(list[1].documentType).toEqual('test2');
				});
			});
		});
	});
});
